import { Box, Typography, Divider } from '@mui/material';
import type { ReactNode } from 'react';
import { FORM_SECTION_GAP } from './formLayout';
import { useI18n } from '../../../i18n/I18nProvider';
import { translateUiText } from '../../../i18n/translateUiText';

interface Props {
  title?: string;
  description?: string;
  children: ReactNode;
  divider?: boolean;
}

export default function FormSection({ title, description, children, divider = false }: Props) {
  const { t } = useI18n();

  return (
    <Box sx={{ mb: FORM_SECTION_GAP }}>
      {(title || description) && (
        <Box sx={{ mb: 2 }}>
          {title && (
            <Typography
              variant="overline"
              sx={{
                display: 'block',
                fontWeight: 700,
                letterSpacing: '0.08em',
                color: 'text.secondary',
                mb: description ? 0.5 : 0,
              }}
            >
              {translateUiText(title, t)}
            </Typography>
          )}
          {description && (
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
              {translateUiText(description, t)}
            </Typography>
          )}
        </Box>
      )}
      {divider && title && <Divider sx={{ mb: 2 }} />}
      {children}
    </Box>
  );
}
